import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'

import { Navbar } from './app/Navbar'

import { PostsList } from './features/posts/PostsList'
import { AddPostForm } from './features/posts/AddPostForm'
import { EditPostForm } from './features/posts/EditPostForm'
import { SinglePostPage } from './features/posts/SinglePostPage'

import { UsersList } from './features/users/UsersList'
import { UserPage } from './features/users/UserPage'

import { NotificationsList } from './features/notifications/NotificationsList'


function App() {
  return (
    <Router>
      <Navbar />
      <div className="App">
        <Switch>
          <Route exact path="/notifications" component={NotificationsList} />
          <Route
            exact path="/"
            render={() => (
              <>  {/* Shorthand for React.Fragment (except that it doesn’t support keys or attributes) 
              We use fragment to add multiple components into the DOM without the need to group them inside a div (unless you wanna have a div style that applies to all the components inside of it),
              because the div adds another node into the DOM, which could leads to performance issues in large projects. */}
                <AddPostForm />
                <PostsList />
              </>
            )}
          />
          <Route exact path="/posts/:postId" component={SinglePostPage} />
          <Route exact path="/editPost/:postId" component={EditPostForm} />
          <Route exact path="/users" component={UsersList} />
          <Route exact path="/users/:userId" component={UserPage} />
          <Redirect to="/" />
        </Switch>
      </div>
    </Router>
  )
}

export default App
